module.exports = __webpack_public_path__ + "static/media/azores-islands.580fd564.svg";